export const SALUTATION_MR = 'MR'
export const SALUTATION_MRS = 'MRS'
export const SALUTATION_UNKNOWN = 'UNKNOWN'
export type Salutation = 'MR' | 'MRS' | 'UNKNOWN'



// WEBPACK FOOTER //
// ./src/types/salutation.js